import { get, filters } from '../../../utils/index'
import { useRoute, useRouter } from 'vue-router/composables'
import { sessionStorage, localStorage } from 'pangu-core'

export function useInitParameters({
  criteriaUrl,
  criteriaCode,
  getCriteriaMenuUrl,
  parametersStorageSuffix = '',
}) {
  const route = useRoute()
  const router = useRouter()

  const getMenu = async (id) => {
    const [res] = await get(getCriteriaMenuUrl, { id })
    const resData = res?.data?.parameter ?? {}
    //特殊值转换
    for (const key in resData) {
      if (
        resData[key] &&
        typeof resData[key] === 'string' &&
        resData[key].indexOf('$today') != -1
      ) {
        const nowTime = new Date().getTime()
        resData[key] = filters(nowTime, 'date', 'YYYY-MM-DD')
      }
    }
    return resData
  }

  const initParameter = async () => {
    const { defaultQueryId, defaultQueryParameters } = route.query ?? {}
    if (defaultQueryId) {
      router.replace({ name: route.name })
      return await getMenu(defaultQueryId)
    } else if (defaultQueryParameters) {
      router.replace({ name: route.name })
      return defaultQueryParameters
    } else {
      return sessionStorage.get(`${route.name}_plus_parameter_${parametersStorageSuffix}`)
    }
  }
  const getCriteria = async () => {
    const [res] = await get(`${criteriaUrl}${criteriaCode ?? ''}`)
    if (res) {
      const defaultParameter = await initParameter()
      return [res.data, defaultParameter]
    } else {
      return Promise.reject({ msg: `【${criteriaUrl}${criteriaCode ?? ''}】请求错误` })
    }
  }

  const setParametersBySessionStorage = (val) =>
    sessionStorage.set(`${route.name}_plus_parameter_${parametersStorageSuffix}`, val)

  //设置pageSize
  const getPageSizeLocalStorage = () =>
    localStorage.get(`${route.name}_plus_page_query_pagesize_${parametersStorageSuffix}`)
  const setPageSizeLocalStorage = (val) =>
    localStorage.set(`${route.name}_plus_page_query_pagesize_${parametersStorageSuffix}`, val)

  return {
    getCriteria,
    getMenu,
    setParametersBySessionStorage,
    getPageSizeLocalStorage,
    setPageSizeLocalStorage,
  }
}
